// $small-break: 375px;
// $medium-break: 834px;
// $large-break: 1280px;
// $extra-large-break: 1536px;
// $extra-extra-large-break: 1920px;

const mobileDownQuery = window.matchMedia('(max-width: 833px)')
const tabletDownQuery = window.matchMedia('(max-width: 1279px)')
const tabletQuery = window.matchMedia('(min-width: 834px)')
const desktopQuery = window.matchMedia('(min-width: 1280px)')
const largeTouchDeviceQuery = window.matchMedia('(hover: none) and (min-width: 1280px)')
const touchDeviceQuery = window.matchMedia('(pointer: coarse)')

const isMobileDown = function () {
  return mobileDownQuery.matches
}

const isTablet = function () {
  return tabletQuery.matches
}

const isTabletDown = function () {
  return tabletDownQuery.matches
}

const isDesktop = function () {
  return desktopQuery.matches
}

const isLargeTouchDevice = function () {
  return largeTouchDeviceQuery.matches
}

const isTouchDevice = function () {
  return touchDeviceQuery.matches
}

const getSize = function () {
  if (isDesktop()) {
    return 'Desktop'
  }
  if (isTablet()) {
    return 'Tablet'
  }
  return 'Mobile'
}

export {
  mobileDownQuery,
  tabletQuery,
  tabletDownQuery,
  desktopQuery,
  largeTouchDeviceQuery,
  isMobileDown,
  isTablet,
  isTabletDown,
  isDesktop,
  getSize,
  isLargeTouchDevice,
  isTouchDevice
}
